import { array, object, string, number } from "yup";

const IndicationSchema = object({
  priceType: string().required("Type is required"),
  product: string().required("Product is required"),
  mode: string().required("Mode is required"),
  competitor: string().optional(),
  quantity: number()
    .min(0, "Quantity must be greater or equal to 0")
    .typeError("Invalid number"),
  startDate: string()
    .required("Start date is required")
    .test("format", "Date is invalid", (value: any) => {
      // eslint-disable-next-line prefer-regex-literals
      const test = new RegExp("^([0-9]{4})-([0-9]{2})-([0-9]{2})$").test(value);
      return test;
    }),
  endDate: string()
    .required("End date is required")
    .test("format", "Date is invalid", (value: any) => {
      // eslint-disable-next-line prefer-regex-literals
      const test = new RegExp("^([0-9]{4})-([0-9]{2})-([0-9]{2})$").test(value);

      return test;
    })
    .test("format", "End date is before start date", (value: any, context) => {
      if (context.parent.startDate > value) {
        return false;
      }

      return true;
    }),
  comments: string().optional(),

  prices: array()
    // .required("Atleast 1 price is required")
    .when("priceType", {
      is: (val: any) => val === "single",
      then: (op) =>
        op
          .of(
            object({
              origin: string().required("Origin is required"),
              fobPrice: number()
                .required("Price is required")
                .moreThan(0, "Price is required")
                .typeError("Invalid number"),
            })
          )
          .min(1, "A minimum of 1 origin price is required"),
      otherwise: (op) =>
        op
          .of(
            object({
              origin: string().required("Origin is required"),
              fobMinPrice: number()
                .required("Price is required")
                .moreThan(0, "Min price is required")
                .typeError("Invalid number"),
              fobMaxPrice: number()
                .required("Price is required")
                .moreThan(0, "Max price is required")
                .typeError("Invalid number"),
            })
          )
          .min(1, "A minimum of 1 origin price is required"),
    }),

  dateLogged: string().optional(),
});

export const IndicationsSchema = object({
  contactName: string().required("Contact is required"),
  party: string().required("Party is required"),
  marketerName: string().optional(),
  uom: string().required(),
  currency: string().required(),
  indications: array().of(IndicationSchema),
});

export const IndicationArraySchema = array().of(IndicationSchema);

export default IndicationSchema;
